import Add from '@mui/icons-material/Add';
import React from 'react';

import './FormDivider.css';

export default function FormDivider({
  title = '',
  hideTopBorder = false,
  hasError = false,
  showAddButton = false,
  buttonTitle = '',
  buttonProps = {},
}) {
  return (
    <div
      data-testid={`form-divider-for-${title.replaceAll(' ', '-')}`}
      className={
        'form-divider sticky-item bg-whisper h-40 bt bb b--nobel flex items-center fw3 fs-14 lh-16 pa-24-horizontal ' +
        (hasError ? 'error-red' : '') +
        (showAddButton ? ' justify-between pr0' : '') +
        (hideTopBorder ? ' bt-0' : '')
      }
    >
      {title}
      {showAddButton && (
        <button
          className="add-btn pa-12-horizontal bg-transparent flex items-center pointer fs-14 lh-16 fw3 bl b--nobel bt-0 bb-0 br-0"
          {...buttonProps}
        >
          <Add />
          {buttonTitle}
        </button>
      )}
    </div>
  );
}
